module.exports = __webpack_public_path__ + "static/media/piso-inferior.be08e579.jpg";